
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/claims-handling",
      function () {
        return require("private-next-pages/solutions/claims-handling/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/claims-handling"])
      });
    }
  